import Vue from 'vue';
import VueCompositionAPI from '@vue/composition-api';
import InstantSearch from 'vue-instantsearch';
import App from './App.vue';

Vue.use(VueCompositionAPI);
Vue.use(InstantSearch);

const search = document.getElementById('search');

if (search) {
    new Vue({
        data: { ...search.dataset },
        render: (h) => h(App)
    }).$mount(search);
}
